import AbstractAuthHttpInterceptor from './AbstractAuthHttpInterceptor';

export default class AbstractStorageCookieBasedAuthHttpInterceptor
    extends AbstractAuthHttpInterceptor {

  constructor(storage) {
    super();
    // console.log('Setting storage', storage);
    this.storage = storage;
  }

  setup(data, notify = true) {
    console.log('Setting up cookie based http interceptor', data);
    this.store(data, notify);
    this.userInfo = data;
    // this.notifier.connect();
  }

  store(userInfo, notify) {
    this.storage.setItem('userInfo', JSON.stringify(userInfo));
    if (notify) {
      // TODO notify other windows/tabs
    }
  }

  removeFromStorage() {
    this.storage.removeItem('userInfo');
    // TODO notify other windows/tabs
  }

  clear() {
    this.userInfo = undefined;
    // this.notifier.disconnect();
    this.removeFromStorage();
  }

  get loggedUser() {
    if (!this.userInfo) {
      const str = this.storage.getItem('userInfo');
      if (str) {
        const obj = JSON.parse(str);
        this.setup(obj, false);
      }
    }
    return this.userInfo;
  }

  get loggedIn() {
    if (!this.userInfo) {
      const str = this.storage.getItem('userInfo');
      if (str) {
        const obj = JSON.parse(str);
        this.setup(obj, false);
      }
    }
    return !!this.userInfo;
  }
}
